module.exports = __webpack_public_path__ + "static/media/fly0241.1270a6e2.webp";